import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { from, switchMap } from 'rxjs';
import { DashboardPersonaService } from '@/app/pages/dashboard/data-access/dashboard-persona.service';
import { DashboardKey } from '@/app/pages/dashboard/models/dashboard.models';
import { isValidDashboardKey } from '@/app/pages/dashboard/registry/dashboard-registry';

export const dashboardGuard: CanActivateFn = (route) => {
  const personaService = inject(DashboardPersonaService);
  const router = inject(Router);
  const key = route.paramMap.get('dashboardKey');
  return from(personaService.getCurrentUserInfo()).pipe(
    switchMap(async (userInfo) => {
      if (!key || !isValidDashboardKey(key)) {
        return router.createUrlTree(['/']);
      }
      if (
        !(await personaService.canAccessDashboard(
          userInfo,
          key as DashboardKey
        ))
      ) {
        const defaultKey =
          await personaService.getDefaultDashboardKey(userInfo);
        return router.createUrlTree(['/dashboards', defaultKey]);
      }
      return true;
    })
  );
};
